import React, { useState } from 'react';
import { X } from 'lucide-react';

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gray-900 text-white py-2 px-4 text-center text-sm relative z-[60]" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 pr-8">
        <span className="text-gray-300">
          BuildPilot App is a <span className="text-white font-medium">BuildPilot</span> product.
        </span>
        <span className="text-gray-400 hidden sm:inline">|</span>
        <span className="hidden sm:inline text-gray-300">
          Looking for one-on-one guidance?{' '}
          <a 
            href="https://www.buildpilot.com.au" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-purple-400 hover:text-purple-300 underline underline-offset-2"
          >
            Visit buildpilot.com.au
          </a>
        </span>
      </div>
      <button 
        onClick={() => setIsVisible(false)}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white p-2 z-[70]"
        aria-label="Close announcement"
        data-testid="close-announcement"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
